import { Checkbox, ICheckboxProps } from "../CheckboxInput/Checkbox";
import { Label } from "../components/Label";

import styles from "../Checkbox.module.scss";

interface ICheckboxLabelProps extends Omit<ICheckboxProps, "size"> {
    /** A sub-label displayed below the main label. */
    subLabel?: string;

    /** The main label of the checkbox. */
    label: string;
}

function CheckboxLabel({
    label,
    subLabel,
    disabled,
    id,
    checked,
    onChange,
    indeterminate,
    dataCy
}: Readonly<ICheckboxLabelProps>): JSX.Element {
    return (
        <div>
            <label
                className={`${styles.checkboxControl} ${styles.brand} ${styles.primary}`}
                htmlFor={id}
            >
                <div className={styles.checkboxWrapper}>
                    <Checkbox
                        disabled={disabled}
                        id={id}
                        checked={checked}
                        onChange={onChange}
                        indeterminate={indeterminate}
                        dataCy={dataCy}
                    />
                    <Label
                        label={label}
                        subLabel={subLabel}
                        disabled={disabled}
                    />
                </div>
            </label>
        </div>
    );
}

export { CheckboxLabel, ICheckboxLabelProps };
